var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 53",
    fill: "#fff",
    stroke: "#95989a",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    rx: 12.875,
    ry: 13.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "M19.431 13.39a.784.784 0 01-.784.784H7.667a.784.784 0 010-1.569h10.98a.784.784 0 01.784.785z",
    fill: "#5300f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircle);
export default __webpack_public_path__ + "static/media/remove-circle.211a3ea1a27443b2de5f5301e5b51eab.svg";
export { ForwardRef as ReactComponent };